import { render, staticRenderFns } from "./breedingInformation.vue?vue&type=template&id=250a9df3&scoped=true"
import script from "./breedingInformation.vue?vue&type=script&lang=js"
export * from "./breedingInformation.vue?vue&type=script&lang=js"
import style0 from "./breedingInformation.vue?vue&type=style&index=0&id=250a9df3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a9df3",
  null
  
)

export default component.exports